// Search overlay toggle

export function searchOverlay() {
  const searchToggle = document.querySelector(".search-icon");

  if (searchToggle) {
    document.addEventListener("DOMContentLoaded", function () {
      document.querySelector("#toggle").addEventListener("click", function () {
        this.classList.toggle("active");
        document.querySelector("#overlay").classList.toggle("open");
      });

      document.querySelector("#close").addEventListener("click", function () {
        document.querySelector("#overlay").classList.toggle("open");
      });

      window.addEventListener("keydown", function (event) {
        if (event.key === "Escape") {
          document.querySelector("#overlay").classList.remove("open");
        }
      });
    });
  }
}
